import React from 'react';
import MainMenu3 from './MainMenu3';
import Topbar3 from './Topbar3';

function Header3() {
    return (
        <>
            <Topbar3 />
            <MainMenu3 />
        </>
    );
}

export default Header3;
